import { createAsyncThunk } from '@reduxjs/toolkit';

export const createThunkHttp = (actionName, httpCall) => createAsyncThunk(
  actionName,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await httpCall(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        status: err.status,
        data: err.data,
      });
    }
  },
);

export const createThunkDictionary = (actionName, httpCall, selector, shouldRefresh) => createAsyncThunk(
  actionName,
  async (payload, { rejectWithValue, getState }) => {
    try {
      const data = selector(getState());

      if (!shouldRefresh && data.length) {
        return data;
      }

      const response = await httpCall(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        status: err.status,
        data: err.data,
      });
    }
  },
);
